import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
import { useParams } from "react-router-dom";

import { useProductsSharings } from "../apis";

export const useProductsSharingsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable({ defaultSorting: [{ id: "CreatedAt", desc: true }] });

  const { resellerId } = useParams();

  const requestParams: GetListRequestParams = {
    page,
    resellerId,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const {
    productsSharings,
    meta,
    isLoading,
    refetch: refetchSharingSchedules
  } = useProductsSharings(requestParams);

  return {
    productsSharings,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchSharingSchedules
  };
};
